const { fetchJSON } = window.BAO.Utils

class HarperPopup extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.mouseX = 0
    this.mouseY = 0

    this.allowPopupToShow = true

    if (this.hasAttribute('data-date')) {
      const openedDate = new Date(this.getAttribute('data-date'))
      const currentDate = new Date()

      // Calculate the difference in milliseconds between currentDate and openedDate
      const timeDifference = currentDate - openedDate

      // Calculate the difference in days
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

      // Check if the difference is greater than or equal to 30 days
      if (daysDifference >= parseInt(this.daysToHidePopupFor)) {
        this.deleteCartAttribute()
      } else {
        this.allowPopupToShow = false
        return
      }
    }

    const userCity = await this.getUserCity()

    const lowercaseCities = this?.dataset?.cities?.toLowerCase() || 'london'
    const citiesArray = lowercaseCities.split(',')
    const isCityInList = citiesArray.includes(userCity)

    if (!isCityInList) {
      this.allowPopupToShow = false
      return
    }

    if (window?.meta?.page?.resourceType !== 'product') return

    this.trackProductViews()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'mousemove', this.handleMousemove.bind(this))

    this.listeners.add(document, 'mouseleave', this.handleMouseleave.bind(this))

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, `click`, this.handleClose.bind(this))
    })
  }

  async deleteCartAttribute () {
    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.popopOpenDate]: null,
        },
      }),
    })
  }

  trackProductViews () {
    if (this.allowPopupToShow === false) return

    if (sessionStorage.getItem(this.productViewsStorageName) === null) {
      sessionStorage.setItem(this.productViewsStorageName, '1')
    } else {
      // If sessionStorage already exists, increment its value
      const currentViews = parseInt(
        sessionStorage.getItem(this.productViewsStorageName),
        10,
      )
      sessionStorage.setItem(
        this.productViewsStorageName,
        (currentViews + 1).toString(),
      )
    }

    const totalPageViews = sessionStorage.getItem(this.productViewsStorageName)

    if (totalPageViews >= parseInt(this.productPageViewsRequired)) {
      this.openPopup()
    }
  }

  handleMousemove (e) {
    if (this.allowPopupToShow === false) return

    this.mouseX = e.clientX
    this.mouseY = e.clientY
  }

  handleMouseleave () {
    if (this.allowPopupToShow === false) return

    if (this.mouseY < 100) {
      this.openPopup()
    }
  }

  async openPopup () {
    if (this.allowPopupToShow === false) return

    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')

    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.popopOpenDate]: new Date(),
        },
      }),
    })

    this.allowPopupToShow = false
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  getUserCity () {
    if (
      window.sessionStorage.getItem(this.sessionStorageName) !== undefined &&
      window.sessionStorage.getItem(this.sessionStorageName) !== null
    ) {
      this.log(
        `${window.sessionStorage.getItem(
          this.sessionStorageName,
        )} from session storage`,
      )
      return window.sessionStorage
        .getItem(this.sessionStorageName)
        .toLowerCase()
    }

    return fetchJSON(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${this.apiKey}&fields=city`,
      { method: 'GET' },
    ).then(res => {
      this.log(`${res.city.toLowerCase()} from ipgeolocation`)
      window.sessionStorage.setItem(
        this.sessionStorageName,
        res.city.toLowerCase(),
      )
      return res.city.toLowerCase()
    })
  }

  get apiKey () {
    return 'ad9951763a9e4db793251dfae7379bd8'
  }

  get sessionStorageName () {
    return 'bao-user-city'
  }

  get popopOpenDate () {
    return 'harper_popup_viewed'
  }

  get productViewsStorageName () {
    return 'bao-product-views'
  }

  get productPageViewsRequired () {
    return this.dataset.productPageViewsRequired || 2
  }

  get daysToHidePopupFor () {
    return this.dataset.daysToHideFor || 30
  }
}

if (!customElements.get('harper-popup')) {
  customElements.define('harper-popup', HarperPopup)
}
